import { useQuery } from '@tanstack/react-query';
import {
  thoughtProcessQueryOptions,
  thoughtProcessQueryKeys,
  type ThoughtProcessParams,
} from '../api/messages';
import type { ThoughtProcess } from '../features/chat/types/conversation';

type ThoughtProcessQueryKey = ReturnType<
  typeof thoughtProcessQueryKeys.detail
>;

interface UseThoughtProcessQueryOptions {
  enabled?: boolean;
}

/**
 * Lightweight wrapper around the shared thought process query options.
 * Enables components to lazily request reasoning data without interacting
 * with the global thought process panel store.
 */
export const useThoughtProcessQuery = (
  params: ThoughtProcessParams,
  options?: UseThoughtProcessQueryOptions,
) => {
  const baseOptions = thoughtProcessQueryOptions(params);

  return useQuery<
    ThoughtProcess,
    Error,
    ThoughtProcess,
    ThoughtProcessQueryKey
  >({
    ...baseOptions,
    enabled:
      options?.enabled ??
      Boolean(params.conversationID && params.messageID),
  });
};
